<script>
import CandelaControl from '@/components/controls/CandelaControl'
export default {
  extends: CandelaControl,
  name: 'candela-slider',
  props: {
    label: {type: String, default: () => 'Untitled'},
    max: {type: Number, default: () => 1},
    min: {type: Number, default: () => 0},
    step: {type: Number, default: () => 0.01}
  }
}
</script>

<template>
<div class='d-flex flex-column justify-center'>
  <div>
  <v-slider v-model='value' :min='min' :max='max' :step='step'
    class='d-flex align-center slider ignore-drag mx-0'
    always-dirty hide-details thumb-label/>
  <div class='primary--text overline font-weight-bold'>{{label}}</div>
  </div>
</div>
</template>

<style lang='sass' scoped>
::v-deep .v-slider--horizontal
  margin: 0
</style>
